// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__31fnD","title":"Images45_title__Sl2-1","images":"Images45_images__1T-H1"};